import { render, staticRenderFns } from "./ParapharmacyPrescriptions.vue?vue&type=template&id=1876616b"
import script from "./ParapharmacyPrescriptions.vue?vue&type=script&lang=js"
export * from "./ParapharmacyPrescriptions.vue?vue&type=script&lang=js"
import style0 from "./ParapharmacyPrescriptions.vue?vue&type=style&index=0&id=1876616b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports